import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import { toast } from 'react-toastify';
import { useRouter } from 'next/router';
import { httpsCallable } from 'firebase/functions';
import { firebaseFunctions } from '../../config/firebaseFunctions';
import { doc, writeBatch } from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import { Radio } from 'antd';
import { envMODE } from '../../config/envMode';
import { getwalletBal } from '../../services/common-query';
import { walletID } from '../../config/fire-conf';
import { useDispatch, useSelector } from 'react-redux';
import { formatUSDBalance } from '@/services/formatBalance';
import { musicartWallet, handCashBSVWallet } from '../../config/wallets';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

var minBidIncreamentVal = 0.01;

if (envMODE === 'PROD') {
  minBidIncreamentVal = 1;
}

export default function PlacebidDialog(props) {
  const router = useRouter();
  const dispatch = useDispatch();

  const bsvRate = useSelector((state) => state.bsvRateReducer.bsvRate);
  const userAuthToken = useSelector((state) => state.authReducer.userauthtoken);
  const handCashWalletRedux = useSelector((state) => state.handCashReducer);

  const [loading, setloading] = useState(false);
  const [bidField, setbidField] = useState('');

  const userWalletRedux = useSelector((state) => state.walletReducer);
  const [isAgreedPolicy, setIsAgreedPolicy] = useState(false);
  const [isAgreedTerms, setIsAgreedTerms] = useState(false);
  const [minBiddingVal, setminBiddingVal] = useState(0);
  const [selectedWallet, setselectedWallet] = useState(musicartWallet);

  useEffect(() => {
    if (props.nftData && props.nftData.minBiddingPrice && bsvRate) {
      let minBid = props.nftData.minBiddingPrice;
      if (props?.nftData?.minBiddingPriceInBSV) {
        let cminBidUSD = props.nftData.minBiddingPrice;
        let cminBidUSDWithCurrentRate = Number(
          (props.nftData.minBiddingPriceInBSV * bsvRate).toFixed(2),
        );

        if (cminBidUSDWithCurrentRate > cminBidUSD) {
          minBid = cminBidUSDWithCurrentRate;
        }
      }

      setminBiddingVal(Number(minBid).toFixed(2));
    }
  }, [props.nftData, bsvRate]);

  const getNftData = (userId) => {
    //get data from nft
  };

  const handleClose = () => {
    props.setdialogState(false);
  };
  const onPolicy = (event) => {
    setIsAgreedPolicy(event.target.checked);
  };

  const onTerms = (event) => {
    setIsAgreedTerms(event.target.checked);
  };

  const placeBid = async (e) => {
    e.preventDefault();

    setloading(true);
    try {
      if (!isAgreedPolicy) {
        toast.error('Please agree to the Privacy Policy.', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setloading(false);
        return;
      }
      if (!isAgreedTerms) {
        toast.error('Please agree to the Terms and Conditions.', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setloading(false);
        return;
      }

      let walletBalance = userWalletRedux.balance;

      if (selectedWallet === handCashBSVWallet) {
        walletBalance = handCashWalletRedux?.balance[1]?.spendableBalance;
      }

      if (walletBalance < Number(bidField / bsvRate)) {
        toast.error('Insufficient balance in wallet', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          zIndex: 2147483641,
        });
        setloading(false);

        return null;
      }

      if (Number(bidField) < Number(minBiddingVal)) {
        toast.error('Bid should be equal or greater than $' + minBiddingVal, {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          zIndex: 2147483641,
        });
        setloading(false);

        return null;
      }

      // placing bid

      let bidAPI = httpsCallable(firebaseFunctions, 'placeAuctionBid');
      let apiRes = await bidAPI({
        bidPrice: Number(Number(bidField) / bsvRate),
        newMinBidPriceBSV: Number(
          (Number(bidField) + minBidIncreamentVal) / bsvRate,
        ),
        newMinBidPriceUSD: Number(Number(bidField) + minBidIncreamentVal),

        userName: props.userDataRedux.displayName,
        userImage: props.userDataRedux.photoURL,
        tokenId: props.nftData.tokenId,
        isMultiple: props.nftData.isMultiple,
        nftId: props.nftData.nftId,
        userAuthToken: userAuthToken,
        wallet: selectedWallet,
      });

      if (apiRes && apiRes.data) {
        if (apiRes.data.status && apiRes.data.status === 'error') {
          toast.error(apiRes.data.msg, {
            position: 'bottom-left',
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            zIndex: 2147483641,
          });
          setloading(false);
        } else if (apiRes.data.status && apiRes.data.status === 'success') {
          toast.success(apiRes.data.msg, {
            position: 'bottom-left',
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            zIndex: 2147483641,
          });

          if (apiRes.data.data) {
            let modifiedObj = { ...props.nftData };
            if (!modifiedObj.bids) {
              modifiedObj.bids = {};
            }
            if (props.nftData.isMultiple) {
              if (
                modifiedObj.multipleNftDetails[props.nftData.nftId] &&
                modifiedObj.multipleNftDetails[props.nftData.nftId].bids
              ) {
                modifiedObj.multipleNftDetails[props.nftData.nftId].bids[
                  apiRes.data.data.id
                ] = apiRes.data.data;
              } else {
                modifiedObj.multipleNftDetails[props.nftData.nftId].bids = {};
                modifiedObj.multipleNftDetails[props.nftData.nftId].bids[
                  apiRes.data.data.id
                ] = apiRes.data.data;
              }

              if (
                modifiedObj?.multipleNftDetails &&
                modifiedObj?.multipleNftDetails[props.nftData.nftId]
              ) {
                modifiedObj.multipleNftDetails[
                  props.nftData.nftId
                ].minBiddingPrice = Number(
                  Number(bidField) + minBidIncreamentVal,
                );
                modifiedObj.multipleNftDetails[
                  props.nftData.nftId
                ].minBiddingPriceInBSV = Number(
                  (Number(bidField) + minBidIncreamentVal) / bsvRate,
                );
              }
            } else {
              modifiedObj.bids[apiRes.data.data.id] = apiRes.data.data;
              modifiedObj.minBiddingPrice = Number(
                Number(bidField) + minBidIncreamentVal,
              );
              modifiedObj.minBiddingPriceInBSV = Number(
                (Number(bidField) + minBidIncreamentVal) / bsvRate,
              );
            }

            if (props.setnftData) {
              props.setnftData(modifiedObj);
            }

            //updating wallet balance
            getwalletBal(walletID, dispatch);
          }
          setbidField('');
          setloading(false);
          handleClose();
        }
      }
    } catch (err) {
      console.log('err', err);
      setloading(false);
      toast.error('An error occured', {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
    }
  };

  return (
    <Dialog
      open={props.open}
      TransitionComponent={Transition}
      keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      PaperProps={{
        style: {
          borderRadius: 20,
          width: 380,
        },
      }}
      disableScrollLock={false}
      style={{ zIndex: 100 }}
      maxWidth="sm"
      onClose={handleClose}
    >
      <form onSubmit={placeBid}>
        <div>
          <div className="dialog-titlebar">
            <div className="dialog-title">Place a bid</div>
            <div className="dialog-close">
              <button
                className="bg-white text-black my-2 text-lg font-light h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300"
                type="button"
                onClick={handleClose}
              >
                <i className="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div>
            <DialogContent>
              <div>
                <div className="py-3">
                  <label className="text-black text-base font-medium mb-4">
                    You are about to place a bid for{' '}
                    <span style={{ fontStyle: 'italic' }}>
                      {props.nftData ? props.nftData.tokenName : ''}
                    </span>
                    .
                  </label>
                </div>
                <div className="text-xl font-bold py-3">Your bid</div>
                <div className="py-3 border-b flex items-center justify-between">
                  <input
                    placeholder="Enter bid"
                    step="any"
                    value={bidField}
                    onChange={(e) => setbidField(e.target.value)}
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    className="outline-none focus:outline-none"
                    style={{ border: '#e3e3e3 1px solid' }}
                    required
                  ></input>
                  <label className="float-right">$</label>
                </div>

                <div className="py-2">
                  <label className="text-gray-500">
                    Total bid amount (${bidField && Number(bidField).toFixed(2)}
                    )
                  </label>
                  <label className="float-right">
                    {bidField && bsvRate && (bidField / bsvRate).toFixed(4)} BSV
                  </label>
                </div>
                <div className="py-2 mb-4">
                  <label className="text-gray-500">
                    Minimum bid amount (${minBiddingVal})
                  </label>
                  <label className="float-right">
                    {(minBiddingVal / bsvRate).toFixed(4) + ' BSV'}
                  </label>
                </div>
                <div className="sign__group sign__group--checkbox custom_check">
                  <input
                    id="isAgreedPolicy"
                    name="isAgreedPolicy"
                    type="checkbox"
                    onChange={onPolicy}
                    checked={isAgreedPolicy}
                  />
                  <label htmlFor="isAgreedPolicy">
                    I have read and agree to the&nbsp;
                    <a href="/privacy-policy" target="_blank">
                      Privacy Policy.
                    </a>
                  </label>
                </div>
                <div className="sign__group sign__group--checkbox custom_check">
                  <input
                    id="isAgreedTerms"
                    name="isAgreedTerms"
                    type="checkbox"
                    onChange={onTerms}
                    checked={isAgreedTerms}
                  />
                  <label htmlFor="isAgreedTerms">
                    I have read and agree to the&nbsp;
                    <a href="/terms-of-service" target="_blank">
                      Terms of Service.
                    </a>
                  </label>
                </div>
              </div>
            </DialogContent>
            <DialogActions
              style={{
                paddingTop: 10,
                paddingBottom: 10,
                justifyContent: 'center',
                boxSizing: 'border-box',
                flexDirection: 'column',
              }}
            >
              <div></div>
              <Radio.Group
                onChange={(e) => {
                  setselectedWallet(e.target.value);
                }}
                value={selectedWallet}
                style={{ width: '100%' }}
                className="mb-6"
              >
                <div className="w-full px-4 mb-2">
                  <button
                    className={`wallet_sel_dialog__btn py-3 rounded-full hover:outline-none focus:outline-none ease-linear w-full ${
                      selectedWallet === musicartWallet
                        ? 'wallet_selected_dialog__btn'
                        : ''
                    }`}
                    type="button"
                    onClick={() => setselectedWallet(musicartWallet)}
                    style={{ textTransform: 'none' }}
                  >
                    <div
                      className="flex align-center"
                      style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <div>
                        {' '}
                        MusicArt Wallet (BSV)
                        <br />
                        Balance:{' '}
                        {userWalletRedux && userWalletRedux.balance
                          ? userWalletRedux.balance.toFixed(4)
                          : 0}{' '}
                        BSV ($
                        {bsvRate && userWalletRedux && userWalletRedux.balance
                          ? formatUSDBalance(userWalletRedux.balance * bsvRate)
                          : 0}
                        )
                      </div>
                      <div style={{ position: 'absolute', right: 0 }}>
                        <Radio value={musicartWallet}> </Radio>
                      </div>
                    </div>
                  </button>
                </div>

                {handCashWalletRedux?.balance &&
                  handCashWalletRedux?.balance[1] && (
                    <div className="w-full px-4 mb-2">
                      <button
                        className={`wallet_sel_dialog__btn py-3 rounded-full hover:outline-none focus:outline-none ease-linear w-full ${
                          selectedWallet === handCashBSVWallet
                            ? 'wallet_selected_dialog__btn'
                            : ''
                        }`}
                        type="button"
                        onClick={() => setselectedWallet(handCashBSVWallet)}
                        style={{ textTransform: 'none' }}
                      >
                        <div>
                          {' '}
                          HandCash Wallet (BSV)
                          <br />
                          Balance:{' '}
                          {handCashWalletRedux?.balance[1]?.spendableBalance
                            ? handCashWalletRedux.balance[1].spendableBalance.toFixed(
                                4,
                              )
                            : 0}{' '}
                          BSV ($
                          {bsvRate &&
                          handCashWalletRedux?.balance[1]?.spendableBalance
                            ? (
                                handCashWalletRedux.balance[1]
                                  .spendableBalance * bsvRate
                              ).toFixed(2)
                            : 0}
                          )
                        </div>
                        <div style={{ position: 'absolute', right: 0 }}>
                          <Radio value={handCashBSVWallet}> </Radio>
                        </div>
                      </button>
                    </div>
                  )}
              </Radio.Group>

              {(() => {
                if (loading) {
                  return (
                    <div className="flex justify-center	w-full mb-6">
                      <i className="fas fa-circle-notch animate-spin text-blueGray-800 mx-auto"></i>
                    </div>
                  );
                } else {
                  return (
                    <div className="w-full mb-4 px-4">
                      <button
                        className="dialog__btn py-3 rounded-full hover:outline-none focus:outline-none ease-linear w-full"
                        type="submit"
                      >
                        Pay with wallet
                      </button>
                      <button
                        className="dialog__btn dialog__btn--white  py-3 my-2 rounded-full hover:outline-none focus:outline-none ease-linear w-full"
                        type="button"
                        onClick={handleClose}
                      >
                        Cancel
                      </button>
                    </div>
                  );
                }
              })()}
            </DialogActions>
          </div>
        </div>
      </form>
    </Dialog>
  );
}
